import React from 'react';
import { Alert, Button } from 'reactstrap';
import { useTranslator, callNativeMobileApp } from '@front-activerse/common-components';
import { useOutletContext } from 'react-router-dom';

const HydrationDayDelete = ({ removeLastPortion = null, messages }) => {
  const { t } = useTranslator();
  const { trackFirebaseEvent } = useOutletContext();

  return (
    <>
      {messages.map((msg) => (
        <Alert key={msg} color="danger" fade={false}>
          {msg}
        </Alert>
      ))}
      <div className="text-center">
        <Button
          size="sm"
          color="link"
          className="remove-last-portion"
          disabled={!removeLastPortion}
          onClick={async () => {
            if (removeLastPortion) {
              await removeLastPortion();
              trackFirebaseEvent('user_action', {
                action: 'tap-remove_water',
                location: 'Hydration',
              });
              callNativeMobileApp({
                action: 'refresh_data',
                payload: {
                  module: 'hydration',
                },
              });
            }
          }}
          data-testid="remove-last-portion-button"
        >
          <b>{t('hydration.addWater.button.remove')}</b>
        </Button>
      </div>
    </>
  );
};

export default HydrationDayDelete;
